import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  max-width: 1529px !important;
  min-width: 633px !important;
`

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${props => props.theme.spacing.sp32};

  & > div:first-child {
    width: 100%;
    height: fit-content;
  }
  & > div:last-child {
    min-width: 360px;
  }

  @media screen and (max-width: 1163px) {
    flex-direction: column;
    & > div:first-child {
      width: auto;
    }
    & > div:last-child {
      max-width: 100%;
    }
  }
`

export const RefundConceptsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
